(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/bingo/bingo-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/bingo/bingo-card.js');
'use strict';

const {
  useRef,
  useEffect
} = React;
const {
  CardBody,
  CardExpandableBody
} = svs.ui.ReactCard;
const {
  WhiteCardHeader,
  PdCard
} = svs.myProfile.react.pages.myInformation.myInformation.components;
const {
  IconMessage
} = svs.tb_ui_react.icon_message;
const {
  BingoSave
} = svs.myProfile.react.pages.myInformation.myInformation.bingo;

const BingoCard = _ref => {
  let {
    aliasBingo,
    isFocused = false
  } = _ref;
  const aliasRef = useRef(null);
  useEffect(() => {
    if (isFocused && aliasRef) {
      aliasRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isFocused]);
  return React.createElement("div", {
    className: svs.core.detect.breakpoint.greaterThan('sm') ? 'scroll-margin-card' : 'scroll-margin-card-mobile',
    ref: aliasRef
  }, React.createElement(PdCard, {
    isFocused: isFocused
  }, React.createElement(WhiteCardHeader, null, "Alias f\xF6r Bingo"), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, React.createElement(IconMessage, {
    className: aliasBingo ? 'padding-top-1' : ''
  }, React.createElement("span", null, "Inget alias angivet"))), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, React.createElement(BingoSave, {
    aliasBingo: aliasBingo
  }))));
};
svs.myProfile.react.pages.myInformation.myInformation.bingo.BingoCard = BingoCard;

 })(window);